<template>
<v-btn v-if="hidden" @click="revealSample" :loading="loading" :disabled="loading || $store.state.testing" small tile color="secondary">Reveal to Customer</v-btn>
<v-btn v-else @click="revealSample" :loading="loading" :disabled="loading || $store.state.testing" small tile color="orange darken-2" dark>Hide from Customer</v-btn>
</template>

<script>
export default {
    name: "revealSample",
    components: {},
    data: () => ({
      loading: false,
    }),
    props: {
      sample_uuid: {
        required: true,
        type: String,
      },
      hidden: {
        required: true,
        type: Boolean,
      }
    },
    methods: {
      async revealSample(){
        this.loading = true;
        await this.$store.$db().model('reportedSamples').api().save({uuid:this.sample_uuid, hidden: !this.hidden})
        this.loading = false;
        this.$emit('refresh')
        await this.$store.dispatch('getHiddenReleases')
      }
    }
}
</script>

<style scoped>

</style>
